import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/customernotifications/NotificationDropdown.css";

/* ── Bell Icon ── */
const SgcBellIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const NotificationDropdown = () => {
  const { baseUrl } = useContext(AppContext);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const viewLatestNotifications = () => {
    const escustomerId = localStorage.getItem("customerId");
    if (!escustomerId) return;

    axios
      .get(`${baseUrl}/customer/notifications/viewLatestNotifications`, {
        params: { escustomer_id: escustomerId },
      })
      .then((response) => {
        setNotifications(response.data.notifications);
        setUnreadCount(response.data.count);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const markAsRead = (id) => {
    const escustomerId = localStorage.getItem("customerId");

    axios
      .post(`${baseUrl}/customer/notifications/updateNotification`, {
        id: id,
        escustomer_id: escustomerId,
      })
      .then(() => {
        viewLatestNotifications();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // const viewLatestNotifications = () => {
  //   axios
  //     .get(`${baseUrl}/customer/notifications/viewLatestNotifications`)
  //     .then((response) => {
  //       console.log(response.data);
  //      setNotifications(response.data.notifications);
  //       setUnreadCount(response.data.count);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // const markAllRead = () => {
  //   axios
  //     .post(`${baseUrl}/customer/notifications/markAllRead`)
  //     .then((response) => {
  //       console.log(response.data);
  //       viewLatestNotifications();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  useEffect(() => {
    viewLatestNotifications();
  }, []);
  return (
    <div className="sgc-notif-dropdown">
      {/* Header */}
      <div className="sgc-notif-dropdown-header">
        <p className="sgc-notif-dropdown-title">Notifications</p>
        <span className="sgc-notif-dropdown-count">{unreadCount} new</span>
      </div>

      {/* Notification List */}

      <div className="sgc-notif-dropdown-list">
        {notifications.map((notif) => (
          <div
            key={notif.id}
            className={`sgc-notif-dropdown-item${
              notif.is_read === false ? " sgc-notif-unread" : ""
            }`}
            onClick={() => !notif.is_read && markAsRead(notif.id)}
            style={{ cursor: "pointer" }}
          >
            {/* Icon */}

            <div className="sgc-notif-dropdown-icon">
              <SgcBellIcon />
            </div>
            {/* Text */}

            <div className="sgc-notif-dropdown-info">
              <p className="sgc-notif-dropdown-item-title">{notif.title}</p>
              <p className="sgc-notif-dropdown-item-body">
                {notif.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="sgc-notif-dropdown-footer">
        {/* <button
          className="sgc-notif-dropdown-view-all"
          onClick={markAllRead}
        >
          Mark all read
        </button> */}

        <NavLink
          to="/customer/notifications"
          className="sgc-notif-dropdown-view-all"
        >
          View all notifications
        </NavLink>
      </div>
    </div>
  );
};

export default NotificationDropdown;
